import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ shape, palette, custom, breakpoints }: Theme) => ({
    root: {},
    section: {
      borderRadius: shape.borderRadius,
      backgroundColor: 'white',
      width: '100%',
      marginTop: 10,
      padding: 20,
    },
    insurantData: {
      display: 'grid',
      gridTemplateColumns: '1fr 1.3fr',
      gap: 20,
      [breakpoints.down(485)]: {
        gridTemplateColumns: '1fr ',
      },
      '& > div': {
        '& > p': {
          margin: '4px 0 4px 0',
          fontSize: 14,
        },
      },
    },
    inputLabel: {
      fontSize: 14,
      fontWeight: 600,
      color: custom.grey[3],
      marginTop: 20,
    },
    countrySelect: {
      '& div[aria-label="select options"]': {
        width: '100% !important',
      },
    },
    bold: {
      fontWeight: 'bold',
    },
    epmhasized: {
      fontWeight: 600,
      color: palette.primary.main,
      wordBreak: 'break-all',
    },
    lenderConsentsHeader: {
      color: custom.grey[3],
      paddingBottom: 10,
    },
    lenderConsents: {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 1.43,
      color: custom.grey[2],
      paddingTop: 15,
    },
    tickRequiredConsents: {
      color: palette.primary.main,
      display: 'flex',
      alignItems: 'center',
      marginBottom: 10,
      '& > span:first-of-type': {
        color: palette.primary.main,
        paddingBottom: 0,
        paddingTop: 0,
      },
      [breakpoints.down(346)]: {
        marginTop: 10,
        marginBottom: 10,
      },
    },
    consentsSection: {
      backgroundColor: custom.grey[8],
      borderRadius: shape.borderRadius,
      padding: '0 5px 0 0',
    },
    consentsContainer: {
      padding: '15px 0 0 15px',
      '& label': {
        '& > span:first-of-type': {
          marginTop: -10,
        },
        '& > span:nth-child(2)': {
          marginLeft: 5,
          lineHeight: '1.33',
          '& > span': {
            fontSize: '12px',
          },
        },
      },
      '& > div': {
        position: 'relative',
        marginBottom: 10,
      },
      '& > div:last-of-type': {
        marginBottom: 15,
      },
    },
    requiredFieldsInfo: {
      fontSize: 13,
      color: custom.grey[2],
      marginTop: 15,
      fontWeight: 'normal',
    },
    requiredFielAsterisk: {
      fontSize: 16,
      color: palette.primary.main,
    },
    consentRequired: {
      position: 'absolute',
      left: 23,
      top: 3,
    },
    submitButton: {
      marginTop: 30,
      minHeight: 50,
      fontSize: 16,
      fontWeight: 900,
    },
    cardIndefinitely: {
      '& label': {
        width: 'auto',
      },
    },
  })
);
